import { put, takeLatest, call } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

// GET TRANSACTIONS FIAT LIST
function* getDeposit({ payload }) {
  try {
    const { data, status } = yield call(api.fiatTransfer.getDeposit, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_FIAT_DEPOSITS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_FIAT_DEPOSITS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* deposit() {
  yield takeLatest(types.GET_FIAT_DEPOSITS_START, getDeposit);
}
